import { useRef, useState } from 'react'

import { Popover } from 'src/shared/ui/Popover'
import { Typography } from 'src/shared/ui/Typography'

import styles from './index.module.css'

type Props = {
  actions: {
    name: string
    onClick: () => void
  }[]
}

export const Dots = ({ actions }: Props) => {
  const anchorElement = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)

  return (
    <div className={styles.component}>
      <Typography ref={anchorElement} view="reg_32" onClick={() => setOpen(!open)}>
        ...
      </Typography>
      <Popover
        open={open}
        onOpenChange={setOpen}
        anchorElement={anchorElement.current}
        position="bottom-end"
        offset={10}
      >
        {actions?.map((action) => (
          <Typography key={action.name} className={styles.action} view="reg_14" onClick={action.onClick}>
            {action.name}
          </Typography>
        ))}
      </Popover>
    </div>
  )
}
